<template>
<div>
	<div class="vx-col w-full mb-base">
		<vs-card class="p-4 mb-6">
            <div slot="header" class="flex flex-wrap items-center justify-between">
                <div class="flex items-center">
                    <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                    <h4 class="ml-3">Wave Pick Planning</h4>
                </div>
                <div class="flex items-center">
                    <!-- <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="createDo">Create Delivery Order</vs-button> -->
                    <!-- <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="editForm" v-if="!editMode" :disabled="data.status.id == 4 ? false : true">Edit</vs-button>
                    <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="submitForm" v-if="editMode">Save</vs-button> -->
                    <vs-dropdown vs-trigger-click>
                        <vs-button class="btn mb-4 md:mb-0 mr-1">Process</vs-button>
                        <vs-dropdown-menu>
                            <vs-dropdown-group vs-collapse vs-label="Movement Order">
                                <vs-dropdown-item > View Movement </vs-dropdown-item>
                                <vs-dropdown-item @click="confirmMovement"> Confirm Movement </vs-dropdown-item>
                            </vs-dropdown-group>
                            <vs-dropdown-item divider @click="checkingAndPacking"> Checking and Packing </vs-dropdown-item>
                            <vs-dropdown-item divider @click="goodIssueInit"> Good Issue All DO </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>
            </div>
            <div class="vx-row mt-6">
                <div class="vx-col lg:w-1/4 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Wave ID
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.id" disabled/>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Wave Date
                        </div>
                        <div class="vx-col w-2/3">
                            <flat-pickr class="w-full" v-model="data.date"/>
                        </div>
                    </div>
                </div>
                <div class="vx-col lg:w-1/4 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Reference
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.reference" disabled/>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Status
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.status" disabled />
                        </div>
                    </div>
                </div>
            </div>
            <vs-tabs class="mt-10">
                <vs-tab label="Picking Summary">
                    <div class="vx-row mt-6">
                        <div class="vx-col lg:w-1/4 w-full">
                            <div class="vx-row mb-3">
                                <div class="vx-col w-1/3">
                                    Picker
                                </div>
                                <div class="vx-col w-2/3">
                                    <vs-input class="w-full" />
                                </div>
                            </div>
                            <div class="vx-row mb-3">
                                <div class="vx-col w-1/3">
                                    Total Volume
                                </div>
                                <div class="vx-col w-2/3">
                                    <vs-input class="w-full" v-model="data.total_volume" disabled/>  
                                </div>
                            </div>
                        </div>
                        <div class="vx-col lg:w-1/4 w-full">
                            <div class="vx-row mb-3">
                                <div class="vx-col w-1/3">
                                    Total Weight
                                </div>
                                <div class="vx-col w-2/3">
                                    <vs-input class="w-full" v-model="data.total_weight" disabled/>
                                </div>
                            </div>
                            <div class="vx-row mb-3">
                                <div class="vx-col w-1/3">
                                    Total Quantity
                                </div>
                                <div class="vx-col w-2/3">
                                    <vs-input class="w-full" v-model="data.total_quantity" disabled/>
                                </div>
                            </div>
                        </div>
                        <div class="vx-col lg:w-1/4 w-full">
                            <div class="vx-row mb-3">
                                <div class="vx-col w-1/3">
                                    Total Order
                                </div>
                                <div class="vx-col w-2/3">
                                    <vs-input class="w-full" v-model="data.total_order" disabled/>
                                </div>
                            </div>
                            <div class="vx-row mb-3">
                                <div class="vx-col w-1/3">
                                    Picking Line
                                </div>
                                <div class="vx-col w-2/3">
                                    <vs-input class="w-full" v-model="data.picking_line" disabled/>
                                </div>
                            </div>
                        </div>
                    </div>
                </vs-tab>
                <vs-tab label="Notes"></vs-tab>
                <vs-tab label="Attachment"></vs-tab>
            </vs-tabs>
		</vs-card>
    </div>
</div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import '@/assets/scss/vuesax/_wmsTheme.scss'

export default {
    components: {
        vSelect,
        AgGridVue,
        flatPickr,
    },
    data() {
        return {
            data: {
                id: '',
                date: new Date(),
                reference: '',
                status: '',
                total_volume: '',
                total_weight: '',
                total_quantity: '',
                total_order: '',
                picking_line: '',
            },
            isLoading: false,
            clientOption: [],
            customerOption: [],
            orderTypeOption: [],
            productOption: [],
            stockTypeOption: [],
            warehouseOption: [],
            withReference: false,
            dataChanged: false
        }
    },
    watch: {
        isLoading: function(){
            if(this.isLoading){
                this.$vs.loading()
            }
            else{
                this.$vs.loading.close()
            }
        },
    },
    methods: {
        back() {
            if(this.dataChanged) {
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: 'Confirmation',
                    text: 'Leave page?',
                    accept: () => {
                        this.$router.push({
                            name: 'wave-pick-planning',
                        })
                    },
                    acceptText: 'Yes',
                    cancelText: 'No'
                });
            }
            else {
                this.$router.push({
                    name: 'wave-pick-planning',
                })
            }
        },
        fetchData() {
            this.isLoading = true

            this.$http.get('outbound/wave_pick/' + this.$route.params.id)
            .then(res => {
                this.data.id = res.data.id
                this.data.reference = res.data.reference
                this.data.date = res.data.date
                this.data.status = res.data.status
                this.data.total_volume = res.data.total_volume
                this.data.total_weight = res.data.total_weight
                this.data.total_quantity = res.data.total_quantity
                this.data.total_order = res.data.total_order
                this.data.picking_line = res.data.picking_line
                this.isLoading = false
            })
            .catch(error => {
                console.log(error)
                this.isLoading = false
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: 'Server Error',
                    text: 'Try again?',
                    accept: () => {
                        this.fetchData()
                    },
                    acceptText: 'Yes',
                    cancelText: 'No'
                });
            })
            .then(() => {
                this.applyWatcher()
            })
        },
        applyWatcher() {
            this.$watch('data', function() {
                this.dataChanged = true
            }, { deep: true });
        },
        confirmMovement() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'success',
                title: 'Confirmation',
                text: 'Confirm all movement orders?',
                accept: () => handler(),
                acceptText: 'Yes',
                cancelText: 'No'
            });
            

            const handler = () => {
                this.isLoading = true
                this.$http.post('outbound/wave_pick/movement/getoutstanding', { id: this.data.id })
                .then(res => {
                    // this.isLoading = false
                    const moData = []
                    res.data.movement_order_id.map(item => {
                        moData.push({
                            'id': item
                        })
                    })
                    acceptMo(moData)
                })
                .catch(error => this.handleError(error))
            }

            const acceptMo = (data) => {
                this.$http.post('putaway/confirmputaway', {'list_putaway': JSON.stringify(data)})
                .then(() => {
                    this.$vs.notify({
                        color: 'success',
                        title: 'Success',
                        iconPack: 'feather',
                        icon:'icon-check',
                        text: 'Success confirm'
                    })
                    this.isLoading = false
                })
                .catch(error => this.handleError(error))
            }
        },
        checkingAndPacking() {
            this.isLoading = true
            this.$http.post('outbound/wave_pick/checkpackstatus', { id: this.$route.params.id })
            .then(res => {
                this.$router.push({
                    name: 'checking-packing',
                    params: {
                        fromDeliveryOrder: true,
                        movement_id: res.data.movement_id,
                        wavepick_id: this.$route.params.id
                    }
                })
            })
            .catch(error => this.handleError(error))
        },
        goodIssueInit() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'success',
                title: 'Wave Pick ' + this.$route.params.id,
                text: 'Good issue all delivery order(s)?',
                accept: this.goodIssue,
                acceptText: 'Yes',
                cancelText: 'No'
            })
        },
        goodIssue() {
            this.isLoading = true
            this.$http.post('outbound/wave_pick/goodissue', {id: this.$route.params.id})
            .then(res => {
                this.$vs.notify({
                    color: 'success',
                    title: 'Success',
                    iconPack: 'feather',
                    icon:'icon-check',
                    text: res.data.message
                })
                this.fetchData()
            })
            .catch(error => {
                console.log('asdasd')
                this.isLoading = false
                const message = error.response.data.message ? error.response.data.message : 'Something went wrong.'
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    iconPack: 'feather',
                    icon:'icon-x',
                    text: message
                })
            })
        }
    },
    mounted() {
        this.fetchData()
    },
}

</script>